module.exports = __webpack_public_path__ + "img/image 23.57a8709e.png";